// @ts-nocheck


import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { FuelCards as FuelCardsComponents } from './../components';
import { fuelCardApi } from './../../../lib/api';
import { setVehicleFuelCard, resetVehicleStatus } from '../../../ducks/vehicle';



const { EditableItem, FuelCardForm } = FuelCardsComponents;














export class FuelCard extends Component {
  state = {
    availableFuelCards: [],
    isLoading: false
  };

  async componentDidMount() {
    await this.fetchAvailableFuelCards();
  }

  fetchAvailableFuelCards = async (search) => {
    this.setState({
      isLoading: true
    });
    let availableFuelCards = [];
    const result = await fuelCardApi.fetchFuelCards({
      search,
      page: 1,
      pageSize: 50,
      nodeId: this.props.employeeBranchOrgUnitId,
      nodeFilterType: 'branchAndChildren'
    });

    if (result) {
      availableFuelCards = result.data;
    }
    this.setState({
      availableFuelCards: availableFuelCards,
      isLoading: false
    });
  };

  // Обновление топливной карты в ТС
  updateFuelCardVehicle = async (fuelCard) => {
    const updatedFuelCard = await fuelCardApi.updateFuelCard(fuelCard);
    const { vehicleId } = updatedFuelCard;
    await this.props.resetVehicleStatus(vehicleId);
    await this.props.setVehicleFuelCard(vehicleId);
  };

  onAdd = async (fuelCard) => {
    await this.updateFuelCardVehicle({
      ...fuelCard,
      vehicleId: this.props.vehicle.id
    });
    await this.fetchAvailableFuelCards();
  };

  onEdit = async (fuelCard) =>
  await this.updateFuelCardVehicle(fuelCard);

  onRemove = async (fuelCard) => {
    const { vehicle } = this.props;
    await fuelCardApi.updateFuelCard({
      ...fuelCard,
      vehicleId: null
    });
    await this.props.resetVehicleStatus(vehicle.id);
    await this.props.setVehicleFuelCard(vehicle.id);
    await this.fetchAvailableFuelCards();
  };

  handleSearch = debounce(
    async (value) => await this.fetchAvailableFuelCards(value),
    500
  );

  render() {
    const { editable, vehicle } = this.props;
    const { availableFuelCards, isLoading } = this.state;
    if (!vehicle) return null;
    return vehicle.fuelCard ?
    <EditableItem
      key={vehicle.fuelCard.id}
      fuelCard={vehicle.fuelCard}
      onChange={this.onEdit}
      onRemove={this.onRemove}
      editable={editable} /> :

    editable ?
    <FuelCardForm
      onSubmit={this.onAdd}
      vehicle={vehicle}
      availableFuelCards={availableFuelCards}
      handleSearch={this.handleSearch}
      fetchData={this.fetchAvailableFuelCards}
      isLoading={isLoading} /> :

    null;
  }
}

export default connect(
  (state) => ({
    employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
  }),
  {
    setVehicleFuelCard,
    resetVehicleStatus
  }
)(FuelCard);
